import { useNavigate } from "@reach/router";
import { RuleEditor } from "./rules/RuleEditor";
import { useCallback, useEffect } from "react";
import { IState } from "store/types";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { isAdminUser } from "lib/utils";
import { getConfig } from "actions/config";

interface IProps {
  path?: string;
  id?: string;
}

export const PageTitle = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 31px;
  line-height: 31px;
  margin: 0px;
  color: #252525;
  padding: 24px;
  text-align: center;
`;

export const RuleEditorPage = ({ id }: IProps) => {
  const config = useSelector((state: IState) => state.config);
  const loading = useSelector((state: IState) => state.loadingConfig);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConfig());
  }, [dispatch]);

  const onCancel = useCallback(() => {
    navigate(`/admin`);
  }, [navigate]);

  if (!loading && config && config.adminIds && !isAdminUser(config.adminIds)) {
    return <PageTitle>You are not authorised to view this page.</PageTitle>;
  }
  return <>{id ? <RuleEditor version={id} onCancel={onCancel} /> : null}</>;
};
